import React from 'react';
import styles from './Services.module.css';
import check from '../../assets/images/check.png';

const Services = () => {
  return (
    <section className={styles.about}>
      <h2 className={styles.title}>Наши услуги</h2>
      <div className={styles.blocks}>
        <div className={styles.block}>
          <div className={styles.list}>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Поиск и закупка товаров у зарубежных поставщиков</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Международная логистика - авиа, авто, Ж/Д, морская и мультимодальная доставка </span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Таможенное оформление и сертификация</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Подбор оптимальных маршрутов и подрядчиков</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Доставка "до двери" с полным сопровождением и персональным менеджером</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Services;
